import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { actionCreators } from './store';
import imgLoginLogo from '../../../assets/images/loginlogo.png';
import Footer from '../../../common/footer';
import './style.css';

class Forget extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			isChangePassType: false,
			isChangeRPassType: false,
		};
		this.togglePassInputType = this.togglePassInputType.bind(this);
		this.toggleRPassInputType = this.toggleRPassInputType.bind(this);
	}
	
	//切换密码框的类型
	togglePassInputType(el){
		if(el.type === 'text'){
			this.setState({
				isChangePassType: false
			})
			el.type = 'password'
		}else{
			this.setState({
				isChangePassType: true
			})
			el.type = 'text'
		}
	}
	
	//切换重复密码框的类型
	toggleRPassInputType(el){
		if(el.type === 'text'){
			this.setState({
				isChangeRPassType: false
			})
			el.type = 'password'
		}else{
			this.setState({
				isChangeRPassType: true
			})
			el.type = 'text'
		}
	}
	
	componentDidMount() {
		this.props.editCaptcha();
	}
	
	render() {
		const { userTel, isUserTel, errUserTel, userPass, isUserPass, errUserPass, userRPass, isUserRPass, errUserRPass, phoneYzm, isErrorPhoneYzm, errPhoneYzm, captcha,
			phonePyzm, isErrorPhonePyzm, errPhonePyzm, sendYzmText, isSendYzmText, sending, getSign, countdown, isManuBtnClick,
			validateUserTel, validateUserPass, validateUserRPass, validateUserYzm, validateUserPYzm, handleUserTelChange, handlePassChange, handleRPassChange, 
			handleYzmChange, handlePYzmChange, editCaptcha, forgetf, handleEnterKey ,getsigncode} = this.props;
		return(
			<div className="lrforget">
				<header>
					<div className="headerin mx1200 mauto clear posr">
						<img src={imgLoginLogo} className="fl m30t" alt=""/>
						<div className="size_18 posa">
							<span className="c_666">还没有大立教育账号?</span>
							<Link to="/register" className="c_blue cursp">
								马上加入
							</Link>
						</div>
					</div>
				</header>
				<div className="main">
					<div className="mainin mx1200 mauto posr">
						<div className="con posa">
							<div className="top textc">
								找回密码
							</div>
							<div className="down">
								<div className={isUserTel ? 'item tel errorcon' : 'item tel'}>
									<input type="text" value={userTel}  ref={node => this.userTelEl = node}
										placeholder="请输入你注册时的手机号" onChange={ev => handleUserTelChange(ev)}
										onBlur={ev => validateUserTel(ev)}/>
									{isUserTel ? (
										<div className="error">{errUserTel}</div>
									) : null}
								</div>
								<div className={isUserPass ? 'item pass errorcon' : 'item pass'}>
									<input type="password"  value={userPass} ref={node => this.passEl = node}
										placeholder="请输入新密码" onChange={ev => handlePassChange(ev)}
										onBlur={ev => validateUserPass(ev, userRPass)}/>
									{isUserPass ? (
										<div className="error">{errUserPass}</div>
									) : null}
									<div className={this.state.isChangePassType ? 'img imgopen' : 'img'}
										onClick={ev =>　this.togglePassInputType(this.passEl)}></div>
								</div>
								<div className={isUserRPass ? 'item pass errorcon' : 'item pass'}>
									<input type="password" value={userRPass} ref={node => this.rpassEl = node}
										placeholder="请再次输入新密码" onChange={ev => handleRPassChange(ev)}
										onBlur={ev =>　validateUserRPass(ev, userPass)}/>
									{isUserRPass ? (
										<div className="error">{errUserRPass}</div>
									) : null}
									<div className={this.state.isChangeRPassType ? 'img imgopen' : 'img'}
										onClick={ev =>　this.toggleRPassInputType(this.rpassEl)}></div>
								</div>
								<div className={isErrorPhoneYzm ? 'item yzm clear errorcon' : 'item yzm clear'}>
									<input type="text" maxLength="4" value={phoneYzm}  ref={node => this.phoneYzmEl = node}
										placeholder="请输入图形验证码" onChange={ev => handleYzmChange(ev)}
										onBlur={ev => validateUserYzm(ev)}/>
									<img className="cursp" onClick={ev => editCaptcha()} src={captcha} alt="验证码"/>
									{isErrorPhoneYzm ? (
										<div className="error">{errPhoneYzm}</div>
									) : null}
								</div>
								<div className={isErrorPhonePyzm ? 'item pyzm clear errorcon' : 'item pyzm clear'}>
									<input type="text" maxLength="6" value={phonePyzm}  ref={node => this.phonePyzmEl = node}
										placeholder="请输入短信验证码" onChange={ev => handlePYzmChange(ev)}
										onKeyPress={ev => handleEnterKey(ev, forgetf, this.userTelEl, this.passEl, this.rpassEl, this.phoneYzmEl, this.phonePyzmEl, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign)}
										onBlur={ev => validateUserPYzm(ev)}
										/>
									{!isSendYzmText && !sending ? (
										<span className="bluebdbtn" onClick={ev => getsigncode(this.userTelEl, isUserTel, countdown)}>{sendYzmText}</span>
									) : null}
									{(!isSendYzmText && sending) || (isSendYzmText && sending) ? (
										<span className="graybtn">{sendYzmText}</span>
									) : null}
									{isErrorPhonePyzm ? (
										<div className="error">{errPhonePyzm}</div>
									) : null}
								</div>
								<div className="item sbbtn">
									{isManuBtnClick ? (
										<button type="button" className="opacity8">找回中，请稍后...</button>
									) : (
										<button onClick={ev => forgetf(this.userTelEl, this.passEl, this.rpassEl, this.phoneYzmEl, this.phonePyzmEl, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign)} type="button" className="cursp">找回密码</button>
									)}	
								</div>
								<div className="item btext clear">
									<Link to="/register" className="c_333 fr">
										没有账号？立即注册
									</Link>
								</div>
								<div className="item btext clear">
									<Link to="/login" className="c_333 fr">
										已有账号？立即登录
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</div>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		userTel: state.getIn(['forget', 'userTel']),
		isUserTel: state.getIn(['forget', 'isUserTel']),
		errUserTel: state.getIn(['forget', 'errUserTel']),
		userPass: state.getIn(['forget', 'userPass']),
		isUserPass: state.getIn(['forget', 'isUserPass']),
		errUserPass: state.getIn(['forget', 'errUserPass']),
		userRPass: state.getIn(['forget', 'userRPass']),
		isUserRPass: state.getIn(['forget', 'isUserRPass']),
		errUserRPass: state.getIn(['forget', 'errUserRPass']),
		phoneYzm: state.getIn(['forget', 'phoneYzm']),
		isErrorPhoneYzm: state.getIn(['forget', 'isErrorPhoneYzm']),
		errPhoneYzm: state.getIn(['forget', 'errPhoneYzm']),
		phonePyzm: state.getIn(['forget', 'phonePyzm']),
		isErrorPhonePyzm: state.getIn(['forget', 'isErrorPhonePyzm']),
		errPhonePyzm: state.getIn(['forget', 'errPhonePyzm']),
		captcha: state.getIn(['forget', 'captcha']),
		sendYzmText: state.getIn(['forget', 'sendYzmText']),
		isSendYzmText: state.getIn(['forget', 'isSendYzmText']),
		sending: state.getIn(['forget', 'sending']),
		getSign: state.getIn(['forget', 'getSign']),
		countdown: state.getIn(['forget', 'countdown']),
		isManuBtnClick: state.getIn(['forget', 'isManuBtnClick']),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		handleUserTelChange(e) {
			let val = e.target.value;
			dispatch(actionCreators.handleUserTelChange(val));
			dispatch(actionCreators.toggleUserTelErr(false, ''));
		},
		handlePassChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handlePassChange(val));
			dispatch(actionCreators.togglePassErr(false, ''));
		},
		handleRPassChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleRPassChange(val));
			dispatch(actionCreators.toggleRPassErr(false, ''));
		},
		handleYzmChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handleYzmChange(val));
			dispatch(actionCreators.toggleYzmErr(false, ''));
		},
		handlePYzmChange(e){
			let val = e.target.value;
			dispatch(actionCreators.handlePYzmChange(val));
			dispatch(actionCreators.togglePYzmErr(false, ''));
		},
		validateUserTel(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号.'));
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(val))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确.'));
				return false;
			}else{
				dispatch(actionCreators.toggleUserTelErr(false, ''));
				return false;
			}
		},
		validateUserPass(e, passr){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入新密码'));
				return false;
			}else if (val.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可。'));
				return false;
			}else if(passr !== '' && val !== passr){
				dispatch(actionCreators.togglePassErr(true, '两次密码输入不一致'));
				return false;
			}else{
				dispatch(actionCreators.togglePassErr(false, ''));
				return false;
			}
		},
		validateUserRPass(e, pass){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleRPassErr(true, '您还没有输入确认密码'));
				return false;
			}else if (val.length < 6){
				dispatch(actionCreators.toggleRPassErr(true, '密码不少于六位，字母、数字都可。'));
				return false;
			}else if (val !== pass){
				dispatch(actionCreators.toggleRPassErr(true, '两次密码输入不一致'));
				return false;
			}else{
				dispatch(actionCreators.toggleRPassErr(false, ''));
				return false;
			}
		},
		validateUserYzm(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.toggleYzmErr(true, '您还没有输入图形验证码'));
				return false;
			}else if(val.length !== 4){
				dispatch(actionCreators.toggleYzmErr(true, '图形验证码长度为4位'));
				return false;
			}else{
				dispatch(actionCreators.validateUserYzm(val));
			}
		},
		validateUserPYzm(e){
			let val = e.target.value;
			if(val === ''){
				dispatch(actionCreators.togglePYzmErr(true, '您还没有短信验证码.'));
				return false;
			}else{
				dispatch(actionCreators.togglePYzmErr(false, ''));
				return false;
			}
		},
		editCaptcha(){
			dispatch(actionCreators.editCaptcha());
		},
		getsigncode(userTelEl, isUserTel, countdown) {
			let userTel = userTelEl.value;
			if(userTel === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号.'));
				userTelEl.focus();
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(userTel))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确.'));
				userTelEl.focus();
				return false;
			}
			if(isUserTel){
				userTelEl.focus();
				return false;
			}
			dispatch(actionCreators.getsigncode(userTel, countdown));
		},
		forgetf(userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign){
			let userTel = userTelEl.value;
			let pass = passEl.value;
			let rpass = rpassEl.value;
			let phoneYzm = phoneYzmEl.value;
			let phonePyzm = phonePyzmEl.value;
			if(userTel === ''){
				dispatch(actionCreators.toggleUserTelErr(true, '您还没有输入手机号.'));
				return false;
			}else if(!(/^(13[0-9]|14[579]|15[0-3,5-9]|16[5,6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(userTel))){
				dispatch(actionCreators.toggleUserTelErr(true, '手机格式不正确.'));
				return false;
			}else if(pass === ''){
				dispatch(actionCreators.togglePassErr(true, '您还没有输入新密码'));
				return false;
			}else if (pass.length < 6){
				dispatch(actionCreators.togglePassErr(true, '密码不少于六位，字母、数字都可。'));
				return false;
			}else if(rpass !== '' && pass !== rpass){
				dispatch(actionCreators.togglePassErr(true, '两次密码输入不一致'));
				return false;
			}else if(rpass === ''){
				dispatch(actionCreators.toggleRPassErr(true, '您还没有输入确认密码'));
				return false;
			}else if (rpass.length < 6){
				dispatch(actionCreators.toggleRPassErr(true, '密码不少于六位，字母、数字都可。'));
				return false;
			}else if (rpass !== pass){
				dispatch(actionCreators.toggleRPassErr(true, '两次密码输入不一致'));
				return false;
			}else if(phoneYzm === ''){
				dispatch(actionCreators.toggleYzmErr(true, '您还没有输入图形验证码'));
				return false;
			}else if(phoneYzm.length !== 4){
				dispatch(actionCreators.toggleYzmErr(true, '图形验证码长度为4位'));
				return false;
			}else if(phonePyzm === ''){
				dispatch(actionCreators.togglePYzmErr(true, '您还没有短信验证码.'));
				return false;
			}
			if(isUserTel){
				userTelEl.focus();
				return false;
			}else if(isUserPass){
				passEl.focus();
				return false;
			}else if(isUserRPass){
				rpassEl.focus();
				return false;
			}else if(isErrorPhoneYzm){
				phoneYzmEl.focus();
				return false;
			}else if(isErrorPhonePyzm){
				phonePyzmEl.focus();
				return false;
			}
			dispatch(actionCreators.forgetf(userTel, pass, phoneYzm, phonePyzm, getSign));
		},
		handleEnterKey(e, forgetf, userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign){
			if(e.nativeEvent.keyCode === 13){
				forgetf(userTelEl, passEl, rpassEl, phoneYzmEl, phonePyzmEl, isUserTel, isUserPass, isUserRPass, isErrorPhoneYzm, isErrorPhonePyzm, getSign);
			}
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Forget);

